import { CombinedMaintenanceState } from './reducers';
import { CombinedMaintenanceItem } from '../types/combinedMaintenance';

export const getCombinedMaintenance = ({ combinedMaintenance }) =>
  combinedMaintenance as CombinedMaintenanceState;
